import styles from './TermsPage.module.css'

/**
 * Страница /terms — пользовательское соглашение (заглушка).
 */
export const TermsPage = () => (
  <article className={styles.article}>
    <h1 className={styles.title}>Пользовательское соглашение</h1>
    <p className={styles.text}>Текст пользовательского соглашения будет размещён здесь.</p>
  </article>
)

export default TermsPage
